import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { FormTextField } from '@hvcgroep/design-system';

import c from 'classnames';
import { addressSuggestSingle, getCategories } from '../../../api';
import formateCentroide from '../../../helpers/formateCentroide';
import DataContext from '../../../contexts/DataContext';

const LocationFields = ({ map, afterAddressUpdate }) => {
  const { t } = useTranslation();
  const { address, updateAddress, updateLatLng, updateCategories, updateInBounds } = useContext(DataContext);
  const formikContext = useFormikContext();

  if (!address) return null;

  // Function to call onBlur of the location fields.
  const fetchAddress = () => {
    const streetName = formikContext.getFieldMeta('streetName').value;
    const houseNumber = formikContext.getFieldMeta('houseNumber').value;
    const postcode = formikContext.getFieldMeta('postcode').value;
    const location = formikContext.getFieldMeta('location').value;
    if (!streetName || !houseNumber || !postcode || !location) return null;
    addressSuggestSingle(`${streetName} ${houseNumber} ${postcode} ${location}`, (address) => {
      const gpsCoordinates = formateCentroide(address.centroide_ll);
      map.flyTo(gpsCoordinates, map.getZoom(), { duration: 0.5 });
      afterAddressUpdate(gpsCoordinates);
      updateAddress(address);
      updateLatLng(gpsCoordinates);
      getCategories(gpsCoordinates, (categories) => {
        updateCategories(categories);
      }, updateInBounds);
    });
  };

  return (
    <div className="LocationFields">
      <div className={c('Form--Group')}>
        <div
          className={c('Form--Input')}
        >
          <FormTextField name="streetName" label={t('reports.stepper.location.input.streetName')} defaultValue={address.straatnaam} onBlur={fetchAddress} />
        </div>
        <div
          className={c('Form--Input')}
        >
          <FormTextField name="houseNumber" label={t('reports.stepper.location.input.houseNumber')} defaultValue={address.huis_nlt} onBlur={fetchAddress} />
        </div>
        <div
          className={c('Form--Input')}
        >
          <FormTextField name="postcode" label={t('reports.stepper.location.input.postcode')} defaultValue={address.postcode} onBlur={fetchAddress} />
        </div>
      </div>
      <FormTextField name="location" label={t('reports.stepper.location.input.location')} defaultValue={address.woonplaatsnaam} onBlur={fetchAddress} />
    </div>
  );
};

export default LocationFields;
